import Constants from '@/js/utils/constants'

let ProjectOperationFlowUtils = {
  COLLECT_STATE: {
    READY:0,//预立项 
    // CREATE_COLLECT: 0, // '项目未创建',
    WAIT_START: 100, // '待开始',
    PREPARING: 200, // '准备中',
    TRY_GATHER: 300, // '试采中',
    GATHER_BACK: 400, // '采集回流中',
    FINISH: 500, // '已完成 ',
    TURN_OFF: 6, // '已关闭 '
  },

  COLLECT_STATE_MAP: {
    '0': '预立项',
    '100': '待开始',
    '200': '准备中',
    '300': '试采中',
    '400': '采集回流中',
    '500': '已完成',
    '600': '已关闭'
  },

  PROJECT_LIST_CARD_OPERATION: {
    EDIT: '编辑',
    READY2FORMAL: '正式立项',
    CLOSE: '终止项目',
    START: '开始',
    START_TRY_COLLECT: '开始试采',
    FINISH_TRY_COLLECT: '试采通过',
    FINISH_PROJECT: '结束项目',
    FINISH_REOPEN: 'reopen',
    CLOSE_REOPEN: 'reopen',
    TURN_OFF: '已关闭',
    CHECK_SCENE_CONFIG: '查看配置文件',
    CREATE_SCENE_CONFIG: '生成配置文件',
    UPDATE_SCENE_CONFIG: '修改配置文件',
    CREATE_QRCODE: '生成二维码',
    RECORD_COLLECT_PROGRESS:'记录采集进展',
    QUIT_PROJECT: '退出项目',
    CONFIG: '配置流程',
    MODIFY: '修改配置',
    MANUAL: '新增手动任务'
  },

  projectDetailOperation(userRole, projectStatus) {
    if (userRole != Constants.PM) {
      console.log(projectStatus)
    } else if (userRole == Constants.PM) {
      console.log(projectStatus)
    }
  }
}
export default ProjectOperationFlowUtils



// WEBPACK FOOTER //
// ./src/js/utils/projectOperationFlow.js